import React from "react";
import LanguageIcon from "@mui/icons-material/Language";
import LinkIcon from "@mui/icons-material/Link";

const LINK_ICON_SIZE = 24;

const SvgIconWrapper = ({ children, title, ...props }) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    width={LINK_ICON_SIZE}
    height={LINK_ICON_SIZE}
    fill="currentColor"
    {...props}
  >
    {title && <title>{title}</title>}
    {children}
  </svg>
);

export const InstagramIcon = (props) => (
  <SvgIconWrapper title="Instagram" {...props}>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.268 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.919 0 3.274-.012 3.584-.069 4.919-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.169-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.919 0-3.273.012-3.584.07-4.919.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </SvgIconWrapper>
);

export const FacebookIcon = (props) => (
  <SvgIconWrapper title="Facebook" {...props}>
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </SvgIconWrapper>
);

export const YouTubeIcon = (props) => (
  <SvgIconWrapper title="YouTube" {...props}>
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </SvgIconWrapper>
);

export const XTwitterIcon = (props) => (
  <SvgIconWrapper title="X (Twitter)" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </SvgIconWrapper>
);

export const TikTokIcon = (props) => (
  <SvgIconWrapper title="TikTok" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </SvgIconWrapper>
);

// Threads: official @ symbol only (path from Meta Threads logo, viewBox 960)
export const ThreadsIcon = (props) => (
  <svg
    role="img"
    viewBox="0 0 960 960"
    width={LINK_ICON_SIZE}
    height={LINK_ICON_SIZE}
    fill="currentColor"
    {...props}
  >
    <title>Threads</title>
    <path d="M404.63 392.13c-11.92-7.93-51.53-35.49-51.53-35.49 33.4-47.88 77.46-66.52 138.36-66.52 43.07 0 79.64 14.52 105.75 42 26.12 27.49 41.02 66.8 44.41 117.07 14.48 6.07 27.85 13.22 39.99 21.4 48.96 33 75.92 82.34 75.92 138.91 0 120.23-98.34 224.67-276.35 224.67-152.84 0-311.63-89.11-311.63-354.45 0-263.83 153.81-353.92 311.2-353.92 72.68 0 243.16 10.76 307.27 222.94l-60.12 15.63C678.33 213.2 574.4 189.14 479.11 189.14c-157.52 0-246.62 96.13-246.62 300.65 0 183.38 99.59 280.8 248.71 280.8 122.68 0 214.15-63.9 214.15-157.44 0-63.66-53.37-94.14-56.1-94.14-10.42 54.62-38.36 146.5-161.01 146.5-71.46 0-133.07-49.47-133.07-114.29 0-92.56 87.61-126.06 156.8-126.06 25.91 0 57.18 1.75 73.46 5.07 0-28.21-23.81-76.49-83.96-76.49-55.15-.01-69.14 17.92-86.84 38.39zm105.8 96.25c-90.13 0-101.79 38.51-101.79 62.7 0 38.86 46.07 51.74 70.65 51.74 45.06 0 91.35-12.52 98.63-107.31-22.85-5.14-39.88-7.13-67.49-7.13z" />
  </svg>
);

// Bluesky: butterfly logo (filled silhouette, Tabler-style path in 24 viewBox)
export const BlueskyIcon = (props) => (
  <SvgIconWrapper title="Bluesky" {...props}>
    <path d="M6.335 5.144c-1.654-1.199-4.335-2.127-4.335.826 0 .59.35 4.953.556 5.661.713 2.463 3.13 2.75 5.444 2.369-4.045.665-4.889 3.208-2.667 5.41 1.03 1.018 1.913 1.59 2.667 1.59 2 0 3.134-2.769 3.5-3.5.333-.667.5-1.167.5-1.5 0 .333.167.833.5 1.5.366.731 1.5 3.5 3.5 3.5.754 0 1.637-.571 2.667-1.59 2.222-2.203 1.378-4.746-2.667-5.41 2.314.38 4.73.094 5.444-2.369.206-.708.556-5.072.556-5.661 0-2.953-2.68-2.025-4.335-.826-2.293 1.662-4.76 5.048-5.665 6.856-.905-1.808-3.372-5.194-5.665-6.856z" />
  </SvgIconWrapper>
);

// Venmo (Simple Icons)
export const VenmoIcon = (props) => (
  <SvgIconWrapper title="Venmo" {...props}>
    <path d="M21.772 13.119c-.267 0-.381-.251-.38-.655 0-.533.121-1.575.712-1.575.267 0 .357.243.357.598 0 .533-.13 1.632-.689 1.632Zm.502-3.377c-1.677 0-2.405 1.285-2.405 2.658 0 1.042.421 1.874 1.693 1.874 1.717 0 2.438-1.406 2.438-2.763 0-1.025-.462-1.769-1.726-1.769Zm-3.833 0c-.558 0-.964.17-1.393.477-.154-.275-.462-.477-.932-.477-.542 0-.947.219-1.247.437l-.04-.364H13.54l-.688 4.354h1.506l.479-3.053c.129-.065.323-.154.518-.154.145 0 .267.049.267.267 0 .056-.016.145-.024.218l-.429 2.722h1.498l.478-3.053c.138-.073.324-.154.51-.154.146 0 .268.049.268.267 0 .056-.017.145-.025.218l-.429 2.722h1.499l.461-2.908c.025-.153.049-.388.049-.549 0-.582-.267-.97-1.037-.97Zm-6.871 0c-.575 0-.98.219-1.287.421l-.017-.348H8.962l-.689 4.354H9.78l.478-3.053c.13-.065.324-.154.518-.154.147 0 .268.049.268.242 0 .081-.024.227-.032.299l-.422 2.666h1.499l.462-2.908c.024-.153.049-.388.049-.549 0-.582-.268-.97-1.03-.97Zm-5.631 1.834c.041-.485.413-.824.697-.824.162 0 .299.097.299.291 0 .404-.713.533-.996.533Zm.843-1.834c-1.604 0-2.382 1.39-2.382 2.698 0 1.01.478 1.817 1.814 1.817.527 0 1.07-.113 1.418-.282l.186-1.26c-.494.25-.874.347-1.271.347-.365 0-.64-.194-.64-.687.826-.008 2.252-.347 2.252-1.453 0-.687-.494-1.18-1.377-1.18Zm-4.239.267c.089.186.146.412.146.743 0 .606-.429 1.494-.777 2.06l-.373-2.989L0 9.969l.705 4.2h1.757c.77-1.01 1.718-2.448 1.718-3.554 0-.347-.073-.622-.235-.889l-1.402.283Z" />
  </SvgIconWrapper>
);

// Twitch (Simple Icons)
export const TwitchIcon = (props) => (
  <SvgIconWrapper title="Twitch" {...props}>
    <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z" />
  </SvgIconWrapper>
);

// Bandsintown (Simple Icons)
export const BandsintownIcon = (props) => (
  <SvgIconWrapper title="Bandsintown" {...props}>
    <path d="M6.399 12.8v4.8H19.2v1.6H4.799V0H0v24h24V12.8H6.399Zm4.801-8H6.399v6.4H11.2V4.8Zm6.4 0h-4.8v6.4h4.8V4.8ZM24 0h-4.8v11.2H24V0Z" />
  </SvgIconWrapper>
);

const urlPatterns = [
  { pattern: /^https?:\/\/(www\.)?instagram\.com\/([^/?#]+)/i, presetId: "instagram", getValue: (m) => m[2] },
  { pattern: /^https?:\/\/(www\.)?(fb\.me|facebook\.com)\/([^/?#]+)/i, presetId: "facebook", getValue: (m) => m[3] },
  { pattern: /^https?:\/\/(www\.)?youtube\.com\/@([^/?#]+)/i, presetId: "youtube", getValue: (m) => m[2] },
  { pattern: /^https?:\/\/(www\.)?(x\.com|twitter\.com)\/([^/?#]+)/i, presetId: "x", getValue: (m) => m[3] },
  { pattern: /^https?:\/\/(www\.)?tiktok\.com\/@?([^/?#]+)/i, presetId: "tiktok", getValue: (m) => m[2] },
  { pattern: /^https?:\/\/(www\.)?threads\.net\/@?([^/?#]+)/i, presetId: "threads", getValue: (m) => m[2] },
  { pattern: /^https?:\/\/(www\.)?bsky\.app\/profile\/([^/?#]+)/i, presetId: "bluesky", getValue: (m) => m[2] },
  { pattern: /^https?:\/\/(www\.)?venmo\.com\/([^/?#]+)/i, presetId: "venmo", getValue: (m) => m[2] },
  { pattern: /^https?:\/\/(www\.)?twitch\.tv\/([^/?#]+)/i, presetId: "twitch", getValue: (m) => m[2] },
  { pattern: /^https?:\/\/(www\.)?bandsintown\.com\/([^/?#]+)/i, presetId: "bandsintown", getValue: (m) => m[2] },
  { pattern: /^https?:\/\/(www\.)?bnds\.us\/([^/?#]+)/i, presetId: "bandsintown", getValue: (m) => m[2] },
];

export function linkToPresetValue(link) {
  const url = (link?.url || "").trim();
  const label = (link?.label || "").trim();
  if (!url) return { presetId: "other", value: "", customLabel: label || "" };
  for (const { pattern, presetId, getValue } of urlPatterns) {
    const m = url.match(pattern);
    if (m) return { presetId, value: getValue(m, url), customLabel: "" };
  }
  // URL didn't match a known pattern; if label matches a preset (e.g. "Website"), use it
  if (label) {
    const byLabel = LINK_PRESETS.find(
      (p) => p.id !== "other" && p.label.toLowerCase() === label.toLowerCase(),
    );
    if (byLabel) return { presetId: byLabel.id, value: url, customLabel: "" };
  }
  return { presetId: "other", value: url, customLabel: label || "" };
}

export function presetValueToLink(presetId, value, customLabel) {
  const trimmed = (value || "").trim();
  if (!trimmed) return null;
  const preset = LINK_PRESETS.find((p) => p.id === presetId);
  if (!preset) return { label: customLabel?.trim() || "Link", url: trimmed };
  if (presetId === "other") return { label: (customLabel || "").trim() || "Link", url: trimmed };
  if (preset.inputType === "username") {
    const val = trimmed.replace(/^@/, "");
    if (presetId === "youtube" && /^https?:\//i.test(val)) {
      return { label: preset.label, url: val };
    }
    const url = preset.urlTemplate.replace("{value}", encodeURIComponent(val));
    return { label: preset.label, url };
  }
  return { label: preset.label, url: trimmed };
}

export const LINK_PRESETS = [
  {
    id: "instagram",
    label: "Instagram",
    inputType: "username",
    placeholder: "Username",
    urlTemplate: "https://instagram.com/{value}",
    Logo: InstagramIcon,
  },
  {
    id: "facebook",
    label: "Facebook",
    inputType: "username",
    placeholder: "Username or profile name",
    urlTemplate: "https://facebook.com/{value}",
    Logo: FacebookIcon,
  },
  {
    id: "youtube",
    label: "YouTube",
    inputType: "username",
    placeholder: "Channel handle (e.g. @mychannel)",
    urlTemplate: "https://youtube.com/@{value}",
    Logo: YouTubeIcon,
  },
  {
    id: "x",
    label: "X (Twitter)",
    inputType: "username",
    placeholder: "Username",
    urlTemplate: "https://x.com/{value}",
    Logo: XTwitterIcon,
  },
  {
    id: "tiktok",
    label: "TikTok",
    inputType: "username",
    placeholder: "Username",
    urlTemplate: "https://tiktok.com/@{value}",
    Logo: TikTokIcon,
  },
  {
    id: "threads",
    label: "Threads",
    inputType: "username",
    placeholder: "Username",
    urlTemplate: "https://www.threads.net/@{value}",
    Logo: ThreadsIcon,
  },
  {
    id: "bluesky",
    label: "Bluesky",
    inputType: "username",
    placeholder: "Handle (e.g. user.bsky.social)",
    urlTemplate: "https://bsky.app/profile/{value}",
    Logo: BlueskyIcon,
  },
  {
    id: "venmo",
    label: "Venmo",
    inputType: "username",
    placeholder: "Username",
    urlTemplate: "https://venmo.com/{value}",
    Logo: VenmoIcon,
  },
  {
    id: "twitch",
    label: "Twitch",
    inputType: "username",
    placeholder: "Username",
    urlTemplate: "https://www.twitch.tv/{value}",
    Logo: TwitchIcon,
  },
  {
    id: "bandsintown",
    label: "Bandsintown",
    inputType: "username",
    placeholder: "Username",
    urlTemplate: "https://bnds.us/{value}",
    Logo: BandsintownIcon,
  },
  {
    id: "website",
    label: "Website",
    inputType: "url",
    placeholder: "https://...",
    urlTemplate: null,
    Logo: LanguageIcon,
  },
  {
    id: "other",
    label: "Other",
    inputType: "other",
    placeholder: "",
    urlTemplate: null,
    Logo: LinkIcon,
  },
];
